export default {
  GROWING: 'growing',
  STARTER: 'starter'
}

export const CUSTOM_BILLING_PLAN = 'CUSTOM'
